import { useTheme } from '../../../../hooks/useTheme';
import { SelectField } from '../SelectField';
import data3dprint from '../../../../config/data3dprint.json';

interface TechnologyFieldProps {
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  isNext?: boolean;
  disabled?: boolean;
}

export function TechnologyField({
  value,
  onChange,
  onFocus,
  onBlur,
  isActive = false,
  isNext = false,
  disabled = false
}: TechnologyFieldProps) {
  const theme = useTheme(state => state.getThemeStyles());

  const options = data3dprint.technologies.map(tech => ({
    id: tech.name,
    name: tech.label,
    description: tech.description
  }));

  return (
    <div className={theme.components.input.variants.select.group}>
      <label 
        htmlFor="technology"
        className={theme.components.input.variants.select.label.base}
      >
        Tecnologia
      </label>
      <SelectField
        name="technology"
        label="Tecnologia"
        options={options}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        isActive={isActive}
        disabled={disabled}
      />
      {value && (
        <span className={theme.components.input.variants.select.description}>
          {options.find(opt => opt.id === value)?.description}
        </span>
      )}
    </div>
  );
} 